/* eslint-disable import/prefer-default-export */
import React, { Component } from 'react';
import {
  Search,
  DataTable,
  Footer,
  TextInput,
  Select,
  SelectItem,
  ContentSwitcher,
  Switch,
  ButtonSkeleton,
  Toggle,
  Tabs,
  Tab,
  SkeletonPlaceholder,
  Loading,
  DataTableSkeleton,
  TableContainer,
  Pagination,
  Form,
  Checkbox,
  DatePicker,
  DatePickerInput,
  FormLabel,
  FormGroup,
  ModalWrapper,
  TableHead,
  Table,
  TableExpandRow,
  TableExpandedRow,
  Accordion,
  AccordionItem,
  TableBody,
  TableRow,
  TableCell,
  TableHeader,
  TableToolbarAction,
  TableToolbar,
  TableToolbarContent,
  TableToolbarMenu,
  Button,
  SkeletonText,
} from 'carbon-components-react';
import Edit16 from '@carbon/icons-react/lib/edit/16';
import View16 from '@carbon/icons-react/lib/view/16'; /* RITM0587358 */
import Delete16 from '@carbon/icons-react/lib/delete/16';
import Add16 from '@carbon/icons-react/lib/add/16';
import Chevrondown16 from '@carbon/icons-react/lib/chevron--down/16';
import { CheckmarkOutline16, CheckmarkFilled20, Download16 } from '@carbon/icons-react/lib/';
import SimpleReactValidator from 'simple-react-validator';
import Data16 from '@carbon/icons-react/lib/data--1/16';
import moment from 'moment';
import { api, dynamic, me } from '../../helpers/api/api';
import AutocompleteInput from '../common/AutocompleteInput';
import {
  RenderDataTableCell,
  NoRecordsPlaceholder,
} from '../../helpers/jsonschemaform/DataTableExtention';
import { showNotification } from '../../helpers/notification/BaseNotification';
import {
  getSuccess,
  getError,
  ENUM_RoleEntity,
  ENUM_RoleCode,
  entitiesLabels,
  apioperation,
  DateFormat,
} from '../../helpers/Constants';
import { switchDateFormat } from '../../helpers/jsonschemaform/customwidget/utils';
import { ConfirmAlertCustom } from '../../helpers/ConfirmAlertCustom';
import { DualListWidget } from '../../helpers/DualList';
import PageBreadCrumb from '../../helpers/PageBreadCrumb';
import DateTimePicker from '../../helpers/DateTimePicker';
import { Online } from '../common/OnLineOffLine';
import FileDownLoadButton from '../common/FileDownloadButton';

const baseUrl = '/users/';
const user = {
  id: undefined,
  email: '',
  name: '',
  name: '',
  validUntil: '9999-12-31',
  surname: '',
  enabled: false,
  userAppModules: [],
  userRoles: [],
  amUsertype: false, // RITM1236093 added new field amUsertype
};

export class ListUsers extends Component {
  constructor(props) {
    super(props);

    let amUser = props ? props.match.path.includes('listusersamgroup') : false; /* RITM0587358 */

    this.toggleSearchForm = this.toggleSearchForm.bind(this);
    this.updateState = this.updateState.bind(this);
    this.handleClickCancelSearch = this.handleClickCancelSearch.bind(this);
    this.onChangeAutocomplete = this.onChangeAutocomplete.bind(this);
    this.onSelectAutocomplete = this.onSelectAutocomplete.bind(this);
    this.validator = new SimpleReactValidator();
    this.state = {
      itemList: [],
      appModuleList: [],
      appRoleList: [],
      appDivision: [],
      appMeDivision: [],
      appWorksites: [],
      idUserEdit: null,
      idToDelete: null,
      userModel: {
        ...user,
        // id: undefined,
        // email: '',
        // name: '',
        // surname: '',
        // enabled: false,
        // validUntil: null,
        // userAppModules: [], //[{IdAppModule:"guid", IdUser:"guid"},{},{}....]
      },
      currentPage: 1,
      pageSize: 10,
      rowCount: 0,
      search: {
        email: '',
        fullName: '',
        enabled: null,
      },
      isOpenSearchForm: false,
      isLoadingList: true,
      isLoadingModules: true,
      isLoadingRoles: true,
      isLoadingDivision: null,
      isLoadingWorkSite: null,
      isLoadingUserData: false,
      isSubmitted: false,
      isEditModal: false,
      isOpenInsertModal: false,
      isOpenDeleteModal: false,
      isDeleting: false,
      selectedSwitchIndex: null,
      selectedRoleEntity: [],
      autocompleteEmail: '',
      autocompleteUsers: [],
      autocompleteLoadingUsers: false,
      amUser: amUser /* RITM0587358 */
    };
  }

  componentDidMount() {
    this.getUsersList();
    this.getAppModule();
    this.getRoles();
    this.getUserDivision();
    this.setState({ isNowEntered: true });
    // this.getWorkSite();
  }

  updateState = (inputName, inputValue, objName) => {
    const statusCopy = { ...this.state };
    statusCopy[objName][inputName] = inputValue;
    this.setState(statusCopy);
  };

  /** ***********API******************* */
  getUsersList(param) {
    this.setState({ isLoadingList: true });

    const data = {
      params: {
        page: param && param.page ? param.page : this.state.currentPage,
        pageSize: param && param.pageSize ? param.pageSize : this.state.pageSize,
        Email: this.state.search.email,
        FullName: this.state.search.fullName,
        Enabled: this.state.search.enabled,
      },
    };

    api
      .getWithParam(baseUrl, data)
      .then((response) => {
        this.setState({
          ...response.data,
        });
      })
      .catch((error) => {
        showNotification.error(
          `${entitiesLabels.ERROR}`,
          getError(error, entitiesLabels.USER, apioperation.GET)
        );
      })
      .finally(() => {
        this.setState({
          isLoadingList: false,
        });
      });
  }

  getAppModule() {
    this.setState({ isLoadingModules: true });

    api
      .getAll(`${baseUrl}modules`)
      .then((response) => {
        const { data } = response;
        this.setState({
          appModuleList: data,
        });
      })
      .catch((error) => {
        showNotification.error(
          `${entitiesLabels.ERROR}`,
          getError(error, entitiesLabels.APPMODULE, apioperation.GET)
        );
      })
      .finally(() => {
        this.setState({
          isLoadingModules: false,
        });
      });
  }

  getRoles() {
    this.setState({ isLoadingRoles: true });

    api
      .getAll(`${baseUrl}roles`)
      .then((response) => {
        const { data } = response;
        this.setState({
          appRoleList: data,
        });
      })
      .catch((error) => {
        showNotification.error(
          `${entitiesLabels.ERROR}`,
          getError(error, entitiesLabels.ROLE, apioperation.GET)
        );
      })
      .finally(() => {
        this.setState(
          {
            isLoadingRoles: false,
          },
          () => {
            this.getSelectedEntityRoles();
          }
        );
      });
  }

  getUserDivision = () => {
    this.setState({ isLoadingMeDivision: true });
    me.getAll('divisions')
      .then((response) => {
        let { data } = response;

        data =
          data != null ? data.map((item) => ({ value: item.id, label: getLabelName(item) })) : [];
        this.setState({
          appMeDivision: data,
        });
      })
      .catch((error) => {
        showNotification.error(
          `${entitiesLabels.ERROR}`,
          getError(error, entitiesLabels.DIVISION, apioperation.GET)
        );
      })
      .finally(() => {
        this.setState({
          isLoadingMeDivision: false,
        });
      });
  };

  getDivision() {
    this.setState({ isLoadingDivision: true });

    api
      .getAll('/division')
      .then((response) => {
        let { data } = response;

        data =
          data != null ? data.map((item) => ({ value: item.id, label: getLabelName(item) })) : [];
        this.setState({
          appDivision: data,
        });
      })
      .catch((error) => {
        showNotification.error(
          `${entitiesLabels.ERROR}`,
          getError(error, entitiesLabels.DIVISION, apioperation.GET)
        );
      })
      .finally(() => {
        this.setState({
          isLoadingDivision: false,
        });
      });
  }

  // Accepts the array and key
  groupBy = (array, key) =>
    // Return the end result
    array.reduce((result, currentValue) => {
      // If an array already present for key, push it to the array. Else create an array and push the object
      (result[currentValue[key]] = result[currentValue[key]] || []).push(currentValue);
      // Return the current iteration `result` value, this will be taken as next iteration `result` value and accumulate
      return result;
    }, {}); // empty object is the initial value for result object

  getWorkSite() {
    this.setState({ isLoadingWorkSite: true });

    api
      .getWithParam('/worksite', { params: { page: 0 } })
      .then((response) => {
        let data = response.data.itemList;

        data =
          data != null
            ? data.map((item) => ({
                value: item.id,
                label: getLabelName(item),
                division: item.division,
              }))
            : [];
        const obj = this.groupBy(data, 'division');

        const result = Object.keys(obj).map((key) => ({
          label: key.toString(),
          options: obj[key],
        }));

        this.setState({
          appWorksites: result,
        });
      })
      .catch((error) => {
        showNotification.error(
          `${entitiesLabels.ERROR}`,
          getError(error, entitiesLabels.WORKSITE, apioperation.GET)
        );
      })
      .finally(() => {
        this.setState({
          isLoadingWorkSite: false,
        });
      });
  }

  getUserForEdit(id) {
    this.setState({
      isEditModal: true,
      isLoadingUserData: true,
      isOpenInsertModal: true,
      isNowEntered: true,
    });

    api
      .get(baseUrl, id)
      .then((response) => {
        this.setState({
          idUserEdit: id,
          autocompleteEmail: response.data.email,
          userModel: response.data,
          isLoadingUserData: false,
          selectedSwitchIndex: null,
        });
      })
      .catch((error) => {
        showNotification.error(
          `${entitiesLabels.ERROR}`,
          getError(error, entitiesLabels.USER, apioperation.GET)
        );
      })
      .finally(() => {
        this.setState(
          {
            isLoadingUserData: false,
          },
          () => {
            this.getSelectedEntityRoles();
          }
        );
      });
  }

  downloadFile() {
    if (this.state.isExportLoading) return;

    this.setState({
      isExportLoading: true,
    });
    api
      .getWithParam(`${baseUrl}excel`, { responseType: 'arraybuffer' })
      .then((response) => {
        // fileDownload(new Blob([response.data]), 'report.xlsx');
        const data = new Blob([response.data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
        const csvURL = window.URL.createObjectURL(data);
        const tempLink = document.createElement('a');
        tempLink.href = csvURL;

        const nomefile = `${'Export_' + 'Users_'}${moment().format('YYYYMMDDHHmmSS')}.xlsx`;
        tempLink.setAttribute('download', nomefile);

        document.body.appendChild(tempLink);
        tempLink.click();
      })
      .catch((error) => {
        showNotification.error(
          `${entitiesLabels.ERROR}`,
          getError(error, 'Download File', apioperation.GET)
        );
      })
      .finally(() => {
        this.setState({
          isExportLoading: false,
        });
      });
  }
  /** ***********API******************* */

  /** ***********Form Ricerca******************* */
  toggleSearchForm(e) {
    e.preventDefault();
    this.setState((oldState) => ({ isOpenSearchForm: !oldState.isOpenSearchForm }));
  }

  handleChangeSearch = (el) => {
    const inputName = el.target.name;
    const inputValue = el.target.value;
    this.updateState(inputName, inputValue, 'search');
  };

  handleClickSearch = (e) => {
    e.preventDefault();
    this.getUsersList({ page: 1 });
  };

  handleClickCancelSearch = (e) => {
    e.preventDefault();
    this.setState(
      {
        search: {
          email: '',
          fullName: '',
          enabled: null,
        },
      },
      () => {
        this.getUsersList({ page: 1 });
      }
    );
  };

  handleChangePaging = (event) => {
    this.getUsersList(event);
  };

  /** ***********Form Ricerca******************* */

  /** ***********Form Utente******************* */
  handleChangeModel = (el) => {
    const inputName = el.target.name;
    const inputValue = el.target.value;
    this.updateState(inputName, inputValue, 'userModel');
  };

  handleChangeAppModule = (value, id) => {
    const oldUserAppModules = this.state.userModel.userAppModules || [];
    const element = oldUserAppModules.find((el) => el.idAppModule == id);

    if (value && element == null) {
      const newelement = { idAppModule: id, idUser: undefined };
      const newUserAppModules = oldUserAppModules.concat([newelement]);
      this.updateState('userAppModules', newUserAppModules, 'userModel');
    } else if (!value && element != null) {
      const newUserAppModules = oldUserAppModules.filter((el) => el.idAppModule !== id);
      this.updateState('userAppModules', newUserAppModules, 'userModel');
    }
  };

  clearInsertForm = () => {
    this.setState({
      userModel: { ...user },
      isSubmitted: false,
      selectedSwitchIndex: null,
      selectedRoleEntity: [],
      autocompleteEmail: '',
    });
  };

  handleSubmitInsert = () => {
    if (this.validator.allValid()) {
      const datiForm = this.state.userModel;
      datiForm.userRoles = this.setSelectedEntityRoles();
      this.setState({
        isSubmitted: true,
      });

      const id = this.state.idUserEdit;
      datiForm.id = this.state.isEditModal ? id : datiForm.id;
      const method = this.state.isEditModal
        ? api.put(baseUrl, datiForm, id)
        : api.post(baseUrl, datiForm);

      method
        .then((response) => {
          if (response.status == 200) {
            this.getUsersList();
            if (!this.state.isEditModal) {
              this.clearInsertForm();
              this.setState({
                isOpenInsertModal: false,
              });
            }
            showNotification.success(
              `${entitiesLabels.SUCCESS}`,
              `${entitiesLabels.USER} ${getSuccess(
                datiForm.email,
                this.state.isEditModal ? apioperation.PUT : apioperation.POST
              )}`
            );
          } else {
            showNotification.error();
          }
        })
        .catch((error) => {
          showNotification.error(
            `${entitiesLabels.ERROR}`,
            getError(
              error,
              entitiesLabels.USER,
              this.state.isEditModal ? apioperation.PUT : apioperation.POST
            )
          );
        })
        .finally(() => {
          this.setState({
            isSubmitted: false,
          });
        });
    } else {
      this.validator.showMessages();
      showNotification.warning(`Warning: ${entitiesLabels.USER} required fields are missing  `);
      this.forceUpdate();
    }
  };

  confirmDelete = (id) => {
    this.setState({
      idToDelete: id,
      isOpenDeleteModal: true,
      isDeleting: false,
    });
  };

  onCloseConfirm = () => {
    this.setState({
      isOpenDeleteModal: false,
    });
  };

  deleteItem = () => {
    const id = this.state.idToDelete;
    this.setState({
      isDeleting: true,
    });
    api
      .delete(baseUrl, id)
      .then((response) => {
        if (response.status == 200) {
          this.setState({
            idToDelete: null,
            isOpenDeleteModal: false,
          });
          this.onCloseConfirm();
          this.getUsersList();
          showNotification.success(
            `${entitiesLabels.SUCCESS}`,
            getSuccess(entitiesLabels.USER, apioperation.DELETE)
          );
        } else {
          showNotification.error();
        }
      })
      .catch((error) => {
        showNotification.error(
          `${entitiesLabels.ERROR}`,
          getError(error, entitiesLabels.USER, apioperation.DELETE)
        );
      })
      .finally(() => {
        this.setState({
          isDeleting: false,
        });
      });
  };

  // getUsername = (id) => {
  //    if (id == null) return '';
  //    let element = this.state.itemList.find(el => el.id == id);
  //    return element != null ? element.fullName : '';
  // }

  addNewUser() {
    this.clearInsertForm();
    this.setState({
      isEditModal: false,
      isOpenInsertModal: true,
    });
  }

  closeInsertForm() {
    this.setState({
      isOpenInsertModal: false,
    });
  }

  handleToggleCA = (value, id) => {
    // onchange toggle widget for CA/CAR
    this.handleChangeDualList(value ? [value] : [], id);
  };

    handleChangeRoleSwitch = (index, role) => {
    if (role.roleEntity == ENUM_RoleEntity.Worksites && this.state.isLoadingWorkSite == null) {
      this.getWorkSite();
    } else if (role.code == ENUM_RoleCode.Administrator && this.state.isLoadingDivision == null) {
      this.getDivision();
    } else if (
      role.code == ENUM_RoleCode.DivisionManager &&
      this.state.isLoadingMeDivision == null
    ) {
      this.getUserDivision();
    }
     this.setState({ selectedSwitchIndex: index });
  };

  handleChangeDualList = (selected, index) => {
    // let newSelectedRoleEntity = Object.assign({}, this.state.selectedRoleEntity);//modifica per singolo ruolo
    const newSelectedRoleEntity = {};
    newSelectedRoleEntity[index] = selected;

    this.setState({ selectedRoleEntity: newSelectedRoleEntity });
  };

  getSelectedEntityRoles() {
    if (!this.state.isLoadingRoles) {
      const appRoles = this.state.appRoleList;
      const idConsolidator = appRoles.findIndex((el) => el.name === 'Division Manager');
      if (idConsolidator >= 0) appRoles[idConsolidator].name = 'Consolidator';
      if (!appRoles) return;

      const userRoles = this.state.userModel.userRoles || [];
      let outResult = {};

      for (let index = 0; index < appRoles.length; index++) {
        const role = appRoles[index];
        const selected = userRoles.filter((el) => el.idRole == role.id);
        if (selected && selected.length) {
          // outResult = {}; // fix solo un ruolo assegnabile all'utente
          if (role.roleEntity == ENUM_RoleEntity.Worksites) {
            // Compiler o Data Approval
            outResult[role.id] = selected.map((item) => item.idWorksite);
          } else if (role.roleEntity == ENUM_RoleEntity.Division) {
            // Division Manager o Administrator
            outResult[role.id] = selected.map((item) => item.idDivision);
          } else if (role.roleEntity == ENUM_RoleEntity.None) {
            // CAR/CA/Compiler
            outResult[role.id] = selected && selected.length ? [true] : [];
          }
        }
      }

      this.setState({
        selectedRoleEntity: outResult,
      });
    } else {
      showNotification.warning('Roles not loaded.');
    }
  }

  setSelectedEntityRoles() {
    const { selectedRoleEntity } = this.state;
    if (!selectedRoleEntity) return null;

    const appRoles = this.state.appRoleList;
    if (!appRoles) return null;

    let newUserRoles = [];

    for (let index = 0; index < appRoles.length; index++) {
      const role = appRoles[index];
      const selectedEntity = selectedRoleEntity[role.id]; // array di: idDivision || idWorksite || true(caso CA/CAR)
      if (!selectedEntity || !selectedEntity.length) continue;

      if (role.roleEntity == ENUM_RoleEntity.Worksites) {
        // Compiler o Data Approval
        newUserRoles = newUserRoles.concat(
          selectedEntity.map((item) => ({ idRole: role.id, idWorksite: item }))
        );
      } else if (role.roleEntity == ENUM_RoleEntity.Division) {
        // Division Manager o Administrator
        newUserRoles = newUserRoles.concat(
          selectedEntity.map((item) => ({ idRole: role.id, idDivision: item }))
        );
      } else if (role.roleEntity == ENUM_RoleEntity.None) {
        // CAR/CA/Compiler
        newUserRoles = newUserRoles.concat([{ idRole: role.id }]);
      }
    }

    return newUserRoles;
  }

  onChangeAutocomplete(event, value) {
    const { userModel } = this.state;

    this.setState({
      isNowEntered: false,
      userModel: {
        email: value,
        name: userModel.name,
        surname: userModel.surname,
      },
      autocompleteEmail: value,
      autocompleteLoadingUsers: true,
      autocompleteUsers: [],
    });
    // console.log(this.state.userModel)
    api
      .getWithParam('users/ad', { params: { s: value } })
      .then((response) => {
        this.setState({ autocompleteUsers: response.data, autocompleteLoadingUsers: false });
      })
      .catch((error) => {
        console.error(error);
        this.setState({ autocompleteLoadingUsers: false });
      });
  }

  onSelectAutocomplete(value, item) {
    this.setState({
      autocompleteEmail: value,
      userModel: {
        email: value,
        name: item.givenName,
        surname: item.surname,
      },
      users: [],
    });
  }

  /** ***********Form Utente******************* */

  /** ***********Render******************* */
  showLoading() {
    const show = (this.state.isEditModal && this.state.isLoadingUserData) || this.state.isSubmitted;
    const descr = this.state.isSubmitted ? 'Saving...' : 'Loading data...';
    return show && <Loading active withOverlay description={descr} />;
    // return (<InlineLoading className="bx--loading-overlay" {...props} />)
  }

  renderSearchform() {
    return (
      this.state.isOpenSearchForm && (
        <div>
          <Form autoComplete="off" className="bx--row">
            <FormGroup legendText="" className="bx--col-md-4">
              <FormLabel>Email</FormLabel>
              <TextInput
                id="inputemail"
                name="email"
                value={this.state.search.email}
                onChange={this.handleChangeSearch}
                placeholder="Input email"
                type="text"
                labelText=""
                className="bx--text-input some-class bx--text-input--light"
              />
            </FormGroup>

            <FormGroup legendText="" className="bx--col-md-4">
              <FormLabel>Full Name</FormLabel>
              <TextInput
                id="inputfullname"
                name="fullName"
                value={this.state.search.fullName}
                onChange={this.handleChangeSearch}
                placeholder="User's full name"
                type="text"
                labelText=""
                className="bx--text-input some-class bx--text-input--light"
              />
            </FormGroup>

            <FormGroup legendText="" className="bx--col-md-4">
              <FormLabel>Enabled</FormLabel>
              <Select
                id="inputenabled"
                name="enabled"
                // className="max-width"
                className="max-width"
                value={this.state.search.enabled || ''}
                light
                inline={false}
                hideLabel
                onChange={this.handleChangeSearch}
              >
                <SelectItem key="all" value="" text="All" />
                <SelectItem key="yes" value text="Yes" />
                <SelectItem key="no" value={false} text="No" />
              </Select>
            </FormGroup>
          </Form>
          <div className="searchFormFooter">
            <Button
              className="button--max-width"
              size="small"
              kind="secondary"
              onClick={this.handleClickCancelSearch}
            >
              Cancel
            </Button>
            <Button className="button--max-width" size="small" onClick={this.handleClickSearch}>
              Search
            </Button>
          </div>
        </div>
      )
    );
  }

  renderInsertForm() {
    const validations = {
      validUntil: this.validator.message('validUntil', this.state.userModel.validUntil, 'required'),
      email: this.validator.message('email', this.state.userModel.email, 'required|email'),
      surname: this.validator.message('surname', this.state.userModel.surname, 'required'),
      name: this.validator.message('name', this.state.userModel.name, 'required'),
      userRoles: this.validator.message('roles', this.setSelectedEntityRoles(), 'required'),
      userAppModules: this.validator.message(
        'modules',
        this.state.userModel.userAppModules,
        'required'
      ),
      };
    const _appModules = this.state.appModuleList || [];
    const _selectedAppModules = this.state.userModel.userAppModules || [];
    const isCheckedAppModules = (idAppModule) => {
      const element = _selectedAppModules.find((el) => el.idAppModule == idAppModule);
      return element != null;
    };
    return (
      <div className="insert-user-form">
        <Form className="bx--grid--full-width">
          {this.showLoading()}
          {/* <FormLabel > Lorem ipsum dolor sit lorem a amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt.</FormLabel> */}

          <div className="bx--row">
            <FormGroup
              legendText=""
              className=" bx--col-md-4 bx--col-lg-4 autocomplete"
              onClick={this.onOpen}
            >
              <FormLabel>Email*</FormLabel>
              {/* <TextInput id="modelemail" name="email" placeholder="Input email" required
                                value={this.state.userModel.email}
                                onChange={this.handleChangeModel}
                                type="text" labelText="" className="bx--text-input  bx--text-input--light" disabled={false} invalid={validations.email != null} />
                                */}
              <AutocompleteInput
                inputProps={{
                  id: 'email',
                  className: 'bx--text-input bx--text-input  bx--text-input--light',
                  placeholder: 'Insert email...',
                  autoComplete: 'off',
                  disabled: this.state.viewType == 'Edit',
                  readOnly: !this.state.amUser /* RITM0587358 */
                }}
                autoComplete="off"
                disabled={false}
                wrapperStyle={{ position: 'relative', width: '100%' }}
                value={this.state.autocompleteEmail}
                items={this.state.autocompleteUsers}
                getItemValue={(item) => item.mail}
                onSelect={this.onSelectAutocomplete}
                onChange={this.onChangeAutocomplete}
                renderMenu={(items, value) => (
                  <div>
                    {value === '' ? null : (
                      <div className="results-container">
                        {this.state.autocompleteLoadingUsers ? (
                          <div className="result">Loading...</div>
                        ) : this.state.isNowEntered ? null : items.length === 0 ? (
                          <div className="result">No matches for "{value}"</div>
                        ) : (
                          items
                        )}
                      </div>
                    )}
                  </div>
                )}
                renderItem={(item, isHighlighted) => (
                  <div
                    className={`result ${isHighlighted ? 'result-highlighted' : ''}`}
                    key={item.mail}
                  >
                    {item.mail}
                  </div>
                )}
              />
              {validations.email}
            </FormGroup>

            <FormGroup legendText="" className="bx--col-md-4 bx--col-lg-4 ">
              <FormLabel>Surname*</FormLabel>
              <TextInput
                id="modelsurname"
                name="surname"
                required
                value={this.state.userModel.surname}
                onChange={this.handleChangeModel}
                type="text"
                labelText=""
                className="bx--text-input  bx--text-input--light"
                disabled={false}
                invalid={validations.surname != null}
                readOnly={!this.state.amUser} /* RITM0587358 */
              />
              {validations.surname}
            </FormGroup>

            <FormGroup legendText="" className=" bx--col-md-4 bx--col-lg-4 ">
              <FormLabel>Name*</FormLabel>
              <TextInput
                id="modelname"
                name="name"
                required
                value={this.state.userModel.name}
                onChange={this.handleChangeModel}
                type="text"
                labelText=""
                className="bx--text-input  bx--text-input--light"
                disabled={false}
                invalid={validations.name != null}
                readOnly={!this.state.amUser} /* RITM0587358 */
              />
              {validations.name}
            </FormGroup>

            <FormGroup legendText="" className="bx--col-md-4 bx--col-lg-4 ">
              <FormLabel>Valid Until*</FormLabel>
              <DateTimePicker
                value={this.state.userModel.validUntil}
                type="date"
                placeholder={DateFormat}
                name="validUntil"
                alt="userModel"
                invalid={validations.validUntil != null}
                onChange={this.updateState}
                disabled={!this.state.amUser} /* RITM0587358 */
                readOnly={!this.state.amUser} /* RITM0587358 */
              />
              {validations.validUntil}
            </FormGroup>

            <FormGroup legendText="" className="bx--col--md-2 bx--col-lg-4 ">
              <FormLabel>Enabled</FormLabel>
              <Checkbox
                id="modelenabled"
                name="enabled"
                required
                labelText="Enabled"
                hideLabel
                checked={
                  this.state.userModel.enabled == null ? false : this.state.userModel.enabled
                }
                onChange={(el) => this.updateState('enabled', el, 'userModel')}
                className="bx--form-item bx--checkbox-wrapper"
                disabled={!this.state.amUser || false} /* RITM0587358 */
              />
            </FormGroup>

            {/* RITM1236093 added new field for AM User */}
            <FormGroup legendText="" className="bx--col--md-2 bx--col-lg-4 ">
              <FormLabel>Application Maintenance User</FormLabel>
              <Checkbox
                id="modelamUsertype"
                name="amUsertype"
                required
                labelText="amUsertype"
                hideLabel
                checked={
                  this.state.userModel.amUsertype == null ? false : this.state.userModel.amUsertype
                }
                onChange={(el) => this.updateState('amUsertype', el, 'userModel')}
                className="bx--form-item bx--checkbox-wrapper"
                disabled={!this.state.amUser || false} 
              />
            </FormGroup>
            {/* End */}

            <FormGroup legendText="" className="bx--col--md-12 bx--col-lg-12 ">
              {/* App Module */}
              <FormLabel>Modules*</FormLabel>
              <div className="bx--row">
                {_appModules.map((item) => (
                  <div key={`AppModules_${item.id}`} className="bx--col-lg-3 bx--col-md-2">
                    <Checkbox
                      id={item.id}
                      key={`AppModulesCkb_${item.id}`}
                      labelText={item.name}
                      checked={isCheckedAppModules(item.id)}
                      onChange={this.handleChangeAppModule}
                      className=" "
                      invalid={validations.userAppModules != null}
                      disabled={!this.state.amUser || false} /* RITM0587358 */
                    />
                  </div>
                ))}
              </div>
              {validations.userAppModules}
            </FormGroup>

            <FormGroup legendText="" className="bx--col--md-12 bx--col-lg-12 ">
              {/* Roles */}
              <FormLabel invalid={validations.userRoles != null}>Roles*</FormLabel>
              {validations.userRoles}
              {this.showDualList()}
            </FormGroup>
          </div>
          {!this.state.amUser && (
            <div className="searchFormFooter">
              <Button
                className="button--max-width"
                kind="secondary"
                onClick={() => this.closeInsertForm()}
              >
                Back
              </Button>
          </div>
          )}
          {this.state.amUser && ( /* RITM0587358 */
            <div className="searchFormFooter">
              <Button
                className="button--max-width"
                kind="secondary"
                onClick={() => this.closeInsertForm()}
              >
                Cancel
              </Button>
              <Button
                className="button--max-width"
                kind="primary"
                onClick={() => this.handleSubmitInsert()}
              >
                Save
              </Button>
            </div>
          )}
        </Form>
      </div>
    );
  }

  showDualList() {
    const division = this.state.appDivision;
    const medivision = this.state.appMeDivision;
      const worksites = this.state.appWorksites;
    const selectedRole = this.state.selectedRoleEntity || [];
    const selectedIndex = this.state.selectedSwitchIndex;
    const _appRoles = this.state.appRoleList || [];
    const role = selectedIndex != null ? _appRoles[selectedIndex] : null;
    const isCorporateAdmin = (this.state.appMeDivision || []).find(
      (el) => el.value.toUpperCase() == 'F50C9FB3-5B6B-4BCD-B97B-CFF130E28FC9'
    ); // CORPORATE

    const roleAdministrator = _appRoles.find((el) => el.code == ENUM_RoleCode.Administrator);
    // solo i Corporate Administrator possono modificare i ruoli degli altri Administrator o crearne di nuovi
    const canEditRoles =
      isCorporateAdmin != null ||
      (roleAdministrator != null &&
        (selectedRole[roleAdministrator.id] == null ||
          selectedRole[roleAdministrator.id].length == 0));

    const getRoleTab = () => {
      if (role == null) return null;

      if (role.roleEntity == ENUM_RoleEntity.Worksites) {
        if (this.state.isLoadingWorkSite)
          return <SkeletonPlaceholder className="dual-list-placeholder max-width" />;
        return (
          <DualListWidget
            disabled={!canEditRoles || !this.state.amUser}
            key={`roleDualList_${role.id}`}
            id={`roleDualList_${role.id}`}
            // options={worksites}
            options={this.state.amUser || (!this.state.amUser && (this.state.userModel.userRoles[0].idRole === role.id)) ? worksites : []}
            selected={selectedRole[role.id]}
            idRole={role.id}
            onChange={this.handleChangeDualList}
          />
        );
      }

      if (role.code == ENUM_RoleCode.Administrator) {
        if (this.state.isLoadingDivision)
          return <SkeletonPlaceholder className="dual-list-placeholder max-width" />;
        return (
          <DualListWidget
            disabled={isCorporateAdmin == null || !this.state.amUser}
            key={`roleDualList_${role.id}`}
            id={`roleDualList_${role.id}`}
            // options={division}
            options={this.state.amUser || (!this.state.amUser && (this.state.userModel.userRoles[0].idRole === role.id)) ? division : []}
            selected={selectedRole[role.id]}
            idRole={role.id}
            onChange={this.handleChangeDualList}
          />
        );
      }

      if (role.code == ENUM_RoleCode.DivisionManager) {
        if (this.state.isLoadingMeDivision)
          return <SkeletonPlaceholder className="dual-list-placeholder max-width" />;
        return (
          <DualListWidget
            disabled={!canEditRoles || !this.state.amUser}
            key={`roleDualList_${role.id}`}
            id={`roleDualList_${role.id}`}
            options={this.state.amUser || (!this.state.amUser && (this.state.userModel.userRoles[0].idRole === role.id)) ? medivision : []}
            // options={medivision}
            selected={selectedRole[role.id]}
            idRole={role.id}
            onChange={this.handleChangeDualList}
          />
        );
      }

      // if (role.roleEntity == ENUM_RoleEntity.None) {
      //     return (<Toggle id={role.id} aria-label="" labelText={role.name} toggled={(selectedRole[role.id] != null && selectedRole[role.id].length > 0)} onToggle={this.handleToggleCA} />);
      // }
    };
    return (
      <div className="dual-list-roles">
        <div className="bx--content-switcher">
          {_appRoles.map((item, index) => (
            <SwitchCustom
              key={`SwitchCustom_${item.id}`}
              onClick={() => this.handleChangeRoleSwitch(index, item)}
              selected={this.state.amUser ? (selectedIndex === index) : null} 
              //selected={selectedIndex === index }
              // disabled={ !this.state.amUser } /* RITM0587358 */
                   
            >
              {selectedRole[item.id] && selectedRole[item.id].length  ? ( 
                <CheckmarkFilled20 className="enabled-roles" fill="#e16e08" />  // pallino arancio //
                 ) :
                null}
              {/* Added by RITM1236093 */}
              {item.name === 'Administrator' && !this.state.userModel.amUsertype ? (
                'Platform Coordinator'
              ) : (
                item.name
              )}
              {/* End */}
            </SwitchCustom>
          ))}
        </div>
        { role &&  (
          <div className="dual-list-roles-tabs">
            <div>
              <div key={`roleTab_${role.id}`}>{getRoleTab()}</div>
            </div>
          </div>
        )}
      </div>
    );

    {
      /* const division = this.state.appDivision; //this.state.appDivision || [];
        const worksites = this.state.appWorksites; //this.state.appWorksites || [];
        const selectedRole = this.state.selectedRoleEntity || [];

        return (
            <div className="dual-list-roles">
                <div className="bx--content-switcher">
                    {
                        _appRoles.map((item, index) => (
                            <SwitchCustom
                                key={"SwitchCustom_" + item.id}
                                onClick={() => this.handleChangeRoleSwitch(index)}
                                selected={this.state.selectedSwitchIndex === index}>
                                {selectedRole[item.id] && selectedRole[item.id].length ? <CheckmarkFilled20 className="enabled-roles" fill="#24a148" /> : null}{item.name}
                            </SwitchCustom>
                        ))
                    }
                </div>
                <div className="dual-list-roles-tabs">
                    <Tabs role="hidden" selected={this.state.selectedSwitchIndex}>
                        {
                            _appRoles.map((item, index) => (
                                <Tab key={"roleTab_" + item.id} index={index}>
                                    {
                                        item.roleEntity == ENUM_RoleEntity.Worksites ?
                                            <DualListWidget key={"roleDualList_" + item.id} id={"roleDualList_" + item.id} options={worksites} selected={selectedRole[item.id]} idRole={item.id} onChange={this.handleChangeDualList} />
                                            :
                                            item.roleEntity == ENUM_RoleEntity.Division ?
                                                <DualListWidget key={"roleDualList_" + item.id} id={"roleDualList_" + item.id} options={division} selected={selectedRole[item.id]} idRole={item.id} onChange={this.handleChangeDualList} />
                                                :
                                                item.roleEntity == ENUM_RoleEntity.None ?
                                                    <Toggle id={item.id} aria-label="" labelText={item.name} toggled={(selectedRole[item.id] != null && selectedRole[item.id].length > 0)} onToggle={this.handleToggleCA} />
                                                    :
                                                    null
                                    }
                                </Tab>
                            ))
                        }
                    </Tabs>
                </div>
            </div>
        ); */
    }
  }

  /** ***********Render******************* */
  render() {
    const headersDataTable = [
      { key: 'fullName', header: 'Full Name' },
      { key: 'email', header: 'Email' },
    ];

    const paginationProps = () => ({
      page: this.state.currentPage || 1,
      totalItems: this.state.rowCount || 0,
      pageSize: this.state.pageSize || 10,
      pageSizes: [10, 20, 30, 40, 50],
      onChange: this.handleChangePaging,
    });

    const confirmDelProps = () => ({
      idToDelete: this.state.idToDelete,
      isDeleting: this.state.isDeleting,
      open: this.state.isOpenDeleteModal, // open state
      onCloseConfirm: this.onCloseConfirm, // no click
      deleteItem: this.deleteItem, // yes click fn()
    });

    const skeletonRowCount =
      this.state.rowCount > 0 && this.state.pageSize > this.state.rowCount
        ? this.state.rowCount
        : this.state.pageSize;

    return (
      <>
        {this.state.isOpenInsertModal ? (
          <PageBreadCrumb
            linkText="User List"
            titleLeft={!this.state.amUser ? 'View User' : this.state.isEditModal ? 'Edit User' : 'Add new User'}
            onClick={() => this.closeInsertForm()}
          />
        ) : (
          <PageBreadCrumb linkTo="/backoffice" linkText="BackOffice" titleLeft="User List" />
        )}
        <div className="mainContainer">
          <ConfirmAlertCustom {...confirmDelProps()} />

          {this.state.isOpenInsertModal ? (
            this.renderInsertForm()
          ) : (
            <>
              <TableToolbar>
                <Online>
                  <Search
                    readOnly
                    light
                    className="search cursor-pointer hiddenSearch"
                    labelText="Search"
                    placeHolderText="Search"
                    id="search-1"
                    onClick={this.toggleSearchForm}
                  />

                  <Button
                    onClick={this.toggleSearchForm}
                    className="buttonPaddingIcon"
                    renderIcon={Data16}
                    iconDescription="Filter"
                  />

                  <FileDownLoadButton
                    onError={(error) => {
                      showNotification.error(
                        `${entitiesLabels.ERROR}`,
                        getError(error, 'Download File', apioperation.GET)
                      );
                    }}
                    onDownLoadStart={() => this.setState({ isExportLoading: true })}
                    onDownLoadEnd={() => this.setState({ isExportLoading: false })}
                    apiUrl={`${baseUrl}excel`}
                    fileName={`${'Export_Users_'}${moment().format('YYYYMMDDHHmmSS')}.xlsx`}
                    className="btn-notext"
                    iconDescription=" "
                    renderIcon={Download16}
                  >
                    {!this.state.isExportLoading ? '' : <Loading />}
                  </FileDownLoadButton>
                </Online>
                {this.state.amUser && (
                  this.state.isLoadingModules || this.state.isLoadingRoles ? (
                    <ButtonSkeleton />
                  ) : (
                    <Online>
                      <Button onClick={() => this.addNewUser()} renderIcon={Add16}>
                        Add new User
                      </Button>
                    </Online>
                  )
                )}                
              </TableToolbar>
              {this.renderSearchform()}
              <DataTable
                rows={this.state.itemList || []}
                headers={headersDataTable}
                useZebraStyles
                size="compact"
                render={({ rows, headers, getHeaderProps, getRowProps }) => (
                  <TableContainer className="bx--grid--full-width">
                    {this.state.isLoadingList ? (
                      <DataTableSkeleton
                        headers={[]}
                        rowCount={skeletonRowCount}
                        zebra={false}
                        compact={false}
                      />
                    ) : (
                      <Table className="">
                        <TableHead className="colorgray">
                          <TableRow>
                            {headers.map((header) => (
                              <TableHeader
                                className={header.type == 'bool' ? 'align-center' : ''}
                                {...getHeaderProps({ header })}
                              >
                                {header.header}
                              </TableHeader>
                            ))}

                            <TableHeader className="align-center">Actions</TableHeader>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {rows == null || rows.length == 0 ? (
                            <NoRecordsPlaceholder colSpan={headers.length + 1} />
                          ) : (
                            rows.map((row) => (
                              <TableRow {...getRowProps({ row })}>
                                {row.cells.map((cell) => (
                                  <RenderDataTableCell
                                    key={cell.id}
                                    cell={cell}
                                    header={headers.find((x) => x.key === cell.info.header)}
                                  />
                                ))}

                                {/* RITM0587358 */}
                                
                                  <TableCell
                                    key={`action-${row.id}`}
                                    className="tableActions align-center"
                                  >
                                    <div>
                                      <Online>
                                        {!this.state.amUser && (
                                          <Button
                                            onClick={() => this.getUserForEdit(row.id)}
                                            size="small"
                                            renderIcon={View16}
                                            iconDescription="View"
                                            title="View User"
                                            kind="ghost"
                                          />
                                        )}
                                        {this.state.amUser && (
                                          <Button
                                            onClick={() => this.getUserForEdit(row.id)}
                                            size="small"
                                            renderIcon={Edit16}
                                            iconDescription="Edit"
                                            title="Edit User"
                                            kind="ghost"
                                          />
                                        )}
                                        {this.state.amUser && (
                                          <Button
                                            onClick={() => this.confirmDelete(row.id)}
                                            size="small"
                                            renderIcon={Delete16}
                                            iconDescription="Delete"
                                            title="Delete User"
                                            kind="ghost"
                                          />
                                        )}
                                      </Online>
                                    </div>
                                  </TableCell>
                                
                                
                              </TableRow>
                            ))
                          )}
                        </TableBody>
                      </Table>
                    )}
                  </TableContainer>
                )}
              />

              <div className="footer-pagination">
                <Pagination {...paginationProps()} />
              </div>
            </>
          )}
        </div>
      </>
    );
  }
}

function SwitchCustom(props) {
  return (
    <button
      role="tab"
      type="button"
      onClick={props.onClick}
      aria-selected={props.selected ? 'true' : 'false'}
      className={`bx--content-switcher-btn ${
        props.selected ? 'bx--content-switcher--selected' : ''
      }`}
      disabled={props.disabled}
    >
      <span className="bx--content-switcher__label">{props.children || props.text}</span>
    </button>
  );
}

function getLabelName(item) {
  return item == null
    ? ''
    : `${item.name} (${item.code}) [${item.inUse ? 'In Use' : 'Not In Use'}]`;
}
